import {IDropdownOption, IDropdownTableHeader} from "@/components/new/table/header/components/DropdownTableHeader";

export interface ITextTableHeader {
    type: 'text';
    label: string;
}
type Props = Omit<ITextTableHeader, 'type'>

export const TextTableHeader = ({label}: Props) => {
    return (
        <h2 className={'font-bold text-lg'}>{label}</h2>
    );
}